import {Component, Input, Output, EventEmitter} from "@angular/core";
import {WatchService} from "../../services/watch.service";


@Component({
    selector: "nv-remove-button",
    templateUrl: "./nv-remove-button.component.html"
})


export class NvRemoveButtonComponent {
    @Input() label:string;
    @Input() container:Object[];
    @Input() item:Object;

    @Input() btnClass: string = "btn-danger";
    @Input() btnSize: string = "btn-sm";

    @Output() remove = new EventEmitter();

    constructor(private watchService:WatchService) {}


    onRemoveClick() {
        let i = this.container.indexOf(this.item);
        if (i < 0) { return; }

        this.container.splice(i, 1);
        this.watchService.notify();

        this.remove.emit(this.item);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-remove-button/nv-remove-button.component.ts